import config from 'config';
import { TERRITORIES } from 'common/constants/territories';

export const isWestTerritory = config.territory === TERRITORIES.west;
export const isEastTerritory = config.territory === TERRITORIES.east;
